module.exports = __webpack_public_path__ + "img/cropped-K_entradas_hor_eus.23dca7d5.jpg";